var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex"},[_c('b-card',{staticClass:"price-card border-0 p-3",class:_vm.theme,style:({..._vm.backgroundColor, ..._vm.color, ..._vm.shadow})},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }